const addScript = src =>
  new Promise((resolve, reject) => {
    const scripts = Array.from(document.querySelectorAll('script'));
    const exist = scripts.some(domEl => src === domEl.src);

    if (exist) resolve({ _state: 'script already exist' });

    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.src = src;
    script.dataset.srs = src;

    document.head.appendChild(script);

    script.onload = resolve;
    script.onerror = reject;
  });

const repeatCheckExist = ({
  target: finishFlagKey = '',
  context = window,
  duration: seconds = 5,
  hop = 200,
  delay = 0,
  silent = false,
}) =>
  new Promise((resolve, reject) => {
    const ms = seconds * 1000;
    const tryouts = [];

    for (let i = 0; i < ms / hop; i += 1) {
      const latency = i * hop + delay;
      const last = tryouts.length ? tryouts[tryouts.length - 1] : null;

      if (!last || latency > last * 2) {
        tryouts.push(latency);
      }
    }

    tryouts.push(ms);

    let tryoutIndex = 0;

    const recursiveSetter = timeout => {
      const error = `Existence of ${finishFlagKey} not confirmed after ${timeout} ms`;

      setTimeout(() => {
        const target = context[finishFlagKey];

        if (target) {
          /* finish */
          resolve(target);
        } else if (tryouts[tryoutIndex + 1]) {
          /* retry */
          if (!silent) window.console.warn(error);
          tryoutIndex += 1;
          recursiveSetter(tryouts[tryoutIndex]);
        } else {
          reject(new Error(`${error} and tryouts limit reached`));
        }
      }, timeout);
    };

    recursiveSetter(tryouts[tryoutIndex]);
  });

export { repeatCheckExist, addScript };
